import {
	booleanAttribute,
	Component,
	forwardRef,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenTableComponent } from "@app/gen-table/gen-table.component"
import { tableNameDisplay } from "@app/helpers"
import { Modalable } from "@app/Modalable"

@Component({
	selector: "app-gen-table-add-item",
	imports: [COMMON_IMPORTS, forwardRef(() => GenTableComponent)],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="gen-table-modal">
			<app-gen-table
				[filterField]="filterField"
				[filterFieldValue]="filterFieldValue"
				[tableName]="tableName"
				[addOnlyMode]="false"
				addOnlyRestOpened
				[newRowInjectedFields]="newRowInjectedFields"
				[fuzzyName]="fuzzyName"
				[restrictedAddMode]="restrictedAddMode"
				[filterFieldApiObject]="filterFieldApiObject"
				(itemAdded)="onClose.emit($event)"
			/>
		</div>
	`,
})
export class GenTableAddItemComponent extends Modalable {
	@Input() tableName: string = ""
	@Input() fuzzyName: string = "" //
	@Input({ transform: booleanAttribute }) restrictedAddMode: boolean = false //
	@Input() newRowInjectedFields: any[] = [] //
	@Input() filterField: string = ""
	@Input() filterFieldValue: any = null
	@Input() filterFieldApiObject: any = null
}
